import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { INITPAGING, NOTIFY } from "../based/Constants";
import CommonModal from "../based/Modal";
import CheckBox from "../based/inputs/CheckBox";
import TFUSelect from "../based/inputs/TFUSelect";
import TextArea from "../based/inputs/TextArea";
import Textbox from "../based/inputs/Textbox";
import PartnerServices from "../based/services/PartnerServices";
import { ListCostDiscountType, ListVoucherDiscountType, VoucherDiscountType } from "./PartnerCostModal";
import TextNumber from "../based/inputs/TextNumber";
import { Notify } from "../based/Notify";

function PartnerCostComboModal({ show, onClose, onSave, modalComboId }) {
    const [model, setModel] = useState({});
    const [dropdown, setDropdown] = useState({}); //dropdown chọn chi phí

    useEffect(() => {
        getDropdown();
    }, []);

    useEffect(() => {
        if (modalComboId > 0) getModalComboId(modalComboId);
        else setModel({});
    }, [modalComboId, show]);

    const getDropdown = async () => {
        const [err, data] = await PartnerServices.GetAppPartnerCostDiscountByPage({ ...INITPAGING, pageNumber: 1, pageSize: 100 });
        if (!err && data && data.listObjects) {
            const dt = data.listObjects.map((item) => ({
                value: +item.id,
                label: item.name,
            }));
            setDropdown(dt);
        } else {
            setDropdown([]);
        }
    };

    const getModalComboId = async (modalComboId) => {
        const [err, data] = await PartnerServices.GetPartnerCostDiscountByComboId(modalComboId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
    };

    const handleSave = async () => {
        const [err, data] = await PartnerServices.CreateUpdatePartnerCostCombo({ ...model, partnerCostDiscountType: 1 });
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Thêm phí thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, "Thất bại", "Thêm phí thất bại");
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} title="Thêm phí Combo" size="md" hiddenFooter>
            <Wrapper>
                <div className="form-group">
                    <label htmlFor="" className="required">
                        Tên loại phí
                    </label>
                    <TFUSelect
                        placeholder="Chọn loại phí"
                        name="costDiscountType"
                        options={ListCostDiscountType}
                        onChanged={(newVal) => {
                            setModel({ ...model, discountType: newVal });
                        }}
                        value={model.discountType}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="" className="required">
                        Tên phí combo
                    </label>
                    <Textbox
                        placeholder="Nhập tên chi phí"
                        value={model.name}
                        name="name"
                        id="name"
                        onChanged={(name, value) => {
                            setModel({ ...model, name: value });
                        }}
                    />
                </div>
                <div className="form-group select-price">
                    <div className="label-section  my-2">
                        <label htmlFor="" className="required">
                            Chọn phí trong Combo (Ít nhất 2)
                        </label>
                        <div className="ml-auto" style={{ width: "120px" }}>
                            <TFUSelect
                                placeholder="Chọn loại"
                                name="valueType"
                                id="valueType"
                                options={ListVoucherDiscountType}
                                value={model.valueType}
                                onChanged={(newVal) => {
                                    setModel({ ...model, valueType: +newVal });
                                }}
                            />
                        </div>
                    </div>
                    <div className="table-shop">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className="center" width="30%">
                                        Phí
                                    </th>
                                    <th className="center">Loại shop</th>
                                    <th className="center required">Phần trăm phí</th>
                                    <th className="center">Phí tối đa</th>
                                    <th className="center">Tùy chỉnh</th>
                                </tr>
                            </thead>
                            <tbody>
                                {model &&
                                    model.listSingleItem &&
                                    model.listSingleItem.map((item, idx) => {
                                        const modelValue = item.partnerCostDiscountValue;

                                        return (
                                            <React.Fragment key={idx}>
                                                <tr>
                                                    <td className="center" rowSpan={2}>
                                                        <TFUSelect
                                                            placeholder="Chọn loại phí"
                                                            options={dropdown}
                                                            value={item.id}
                                                            onChangedObject={(selected) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].name = selected.label;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                            name={`costDiscountId_${idx}`}
                                                        />
                                                    </td>
                                                    <td className="vertical-align-middle">Shop thường</td>
                                                    <td className="vertical-align-middle">
                                                        <TextNumber
                                                            placeholder="Nhập"
                                                            value={modelValue.normalShopValue}
                                                            name={`normalShopValue_${idx}`}
                                                            id={`normalShopValue_${idx}`}
                                                            onChanged={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.normalShopValue = +value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                            suffix={model.valueType == VoucherDiscountType.Percentage ? "%" : "đ"}
                                                        />
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <TextNumber
                                                            placeholder="Nhập"
                                                            value={modelValue.normalShopMaxValue}
                                                            name={`normalShopMaxValue_${idx}`}
                                                            id={`normalShopMaxValue_${idx}`}
                                                            onChanged={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.normalShopMaxValue = +value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                            suffix={"đ"}
                                                        />
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <CheckBox
                                                            name={`normalShopEditable_${idx}`}
                                                            id={`normalShopEditable_${idx}`}
                                                            checked={modelValue.normalShopEditable}
                                                            onCheckedChange={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.normalShopEditable = value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="vertical-align-middle">Shop mall</td>
                                                    <td className="vertical-align-middle">
                                                        <TextNumber
                                                            name={`mallShopValue_${idx}`}
                                                            id={`mallShopValue_${idx}`}
                                                            placeholder="Nhập"
                                                            value={modelValue.mallShopValue}
                                                            onChanged={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.mallShopValue = +value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                            suffix={model.valueType == VoucherDiscountType.Percentage ? "%" : "đ"}
                                                        />
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <TextNumber
                                                            placeholder="Nhập"
                                                            name={`mallShopMaximum_${idx}`}
                                                            id={`mallShopMaximum_${idx}`}
                                                            value={modelValue.mallShopMaximum}
                                                            onChanged={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.mallShopMaximum = +value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                            suffix={"đ"}
                                                        />
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <CheckBox
                                                            name={`mallShopEditable_${idx}`}
                                                            id={`mallShopEditable_${idx}`}
                                                            checked={modelValue.mallShopEditable}
                                                            onCheckedChange={(name, value) => {
                                                                const newList = [...model.listSingleItem];
                                                                newList[idx].partnerCostDiscountValue.mallShopEditable = value;
                                                                setModel({ ...model, listSingleItem: newList });
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                            </tbody>
                        </table>
                        <a
                            href=""
                            className="text text-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                const newList = model.listSingleItem ? [...model.listSingleItem] : [];
                                newList.push({
                                    id: 0,
                                    name: "",
                                    partnerCostDiscountValue: {
                                        normalShopValue: 0,
                                        normalShopMaxValue: 0,
                                        normalShopEditable: false,
                                        mallShopValue: 0,
                                        mallShopMaximum: 0,
                                        mallShopEditable: false,
                                    },
                                });
                                setModel({ ...model, listSingleItem: newList });
                            }}
                        >
                            Thêm phí <i className="fa fa-plus" />
                        </a>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="">Nội dung</label>
                    <TextArea
                        placeholder="Nhập nội dung"
                        value={model.description}
                        name="description"
                        id="description"
                        onChanged={(name, value) => {
                            setModel({ ...model, description: value });
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="">Link chi tiết</label>
                    <Textbox
                        placeholder="Nhập link"
                        value={model.linkDetail}
                        name="linkDetail"
                        id="linkDetail"
                        onChanged={(name, value) => {
                            setModel({ ...model, linkDetail: value });
                        }}
                    />
                </div>
                <div className="list-action-button">
                    <button
                        className="btn btn-danger m-1"
                        onClick={(e) => {
                            e.preventDefault();
                            onClose();
                        }}
                    >
                        Đóng
                    </button>
                    <button
                        className="btn btn-custom m-1"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                        }}
                    >
                        Xác nhận
                    </button>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PartnerCostComboModal;

const Wrapper = styled.div`
    .list-action-button {
        display: flex;
        justify-content: center;
    }
    .label-section {
        display: flex;
        align-items: center;
    }

    .label-section label.required {
        margin: 0;
    }
`;
